// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-container":"Breadcrumb_breadcrumb-container___dqpT"};